import Api from '../http.service';

export const getAll = () => Api.GET({ url: `credit_status/` });
